import { ApiCode } from "./ApiCode"
import { SystemCode } from "./SystemCode";

/**
 * @deprecated 不允许再使用此配置文件，请使用多语言配置
 */
export const AppCode = Object.assign({}, ApiCode, SystemCode);